import { Button } from "@/components/ui/button";
import EditPen from "@/assets/svg/EditPen.svg";
import {
  ChangeEvent,
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import useReAssignTaskMutation from "@/api/mutation/useReAssingTaskMutation";
import { OrganisationType } from "@/api/mutation/useOrganisationMutation";
import {
  useLocation,
  useParams,
  useBlocker,
  useNavigate,
} from "react-router-dom";
import EditNewTable from "@/assets/svg/EditNewTable.svg";
import useAddOrganisationMemberMutation from "@/api/mutation/useAddOrganisationMemberMutation";
import useOrganisationRemoveMemberMutation from "@/api/mutation/useOrganisationRemoveMemberMutation";
import useUpdateOrganisationMemberMutation from "@/api/mutation/useUpdateOrganisationMemberMutation";
import Close from "../../assets/svg/CrossIcon.svg";
import MailResendIcon from "@/assets/svg/mailResendIcon.svg";
import SendIcon from "@/assets/svg/sendIcon.svg";
import {
  addMemberToOrgSchema,
  addOrganisationMemberSchema,
  assignProjectAndRoleToUserSchema,
  organisationUserBlockUnblockSchema,
  OrgListOfNonWorkingDaysEnum,
  reAssginedTaskSchema,
} from "@backend/src/schemas/organisationSchema";
import useUserStatusMutation from "@/api/mutation/userUserStatusMutation";
import { useFormik } from "formik";
import useOrganisationDetailsQuery, {
  OrganisationResponseType,
  UserOrganisationType,
} from "@/api/query/useOrganisationDetailsQuery";
import { z } from "zod";
import {
  UserRoleEnumValue,
  UserStatusEnumValue,
  PlanTypeEnumSchema,
  BillingCycleSchema,
  ExtendPlanTypeEnumSchema,
} from "@backend/src/schemas/enums";
import { toFormikValidationSchema } from "zod-formik-adapter";
import { isAxiosError } from "axios";
import { toast } from "react-toastify";
import { useUser } from "@/hooks/useUser";
import useDebounce from "@/hooks/useDebounce";
import useResendInvitationMutation from "@/api/mutation/useResendUserInvitaionMutation";
import useProjectQuery, { Project } from "@/api/query/useProjectWithoutCalulationQuery";
import useAssignProjectAndRoleToUserMutation from "@/api/mutation/useAssignProjectAndRoleToUser";
import Table, { ColumeDef } from "@/components/shared/Table";
import {
  CalendarIcon,
  CheckIcon,
  LucideAlertTriangle,
  ScrollText,
} from "lucide-react";
import {
  OrganisationNoPopupForm,
  SubmitRef,
} from "./organisationForm/organisationNoPopupForm";
import InputText from "@/components/common/InputText";
import UserAvatar from "@/components/ui/userAvatar";
import Dialog, { DialogRef } from "@/components/common/Dialog";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import User from "@/assets/svg/AssignUser.svg";
import Absence from "@/assets/svg/absence.svg";
import TrashCan from "../../assets/svg/TrashCan.svg";
import UserBlock from "../../assets/svg/UserBlock.svg";
import Active from "../../assets/svg/Active.svg";
import InputEmail from "@/components/common/InputEmail";
import { cn } from "@/lib/utils";
import NewEditIcon from "@/assets/svg/NewEditIcon.svg";
import { errorConfig } from "@/lib/toastError";
import ErrorMessage from "@/components/common/ErrorMessage";
import { useTranslation } from "react-i18next";
import Loader from "@/components/common/Loader";
import { errorKeyFormate } from "@/helperFuntions/errroMessage";
import { usePlanValidation } from "@/hooks/usePlan";
import Warning from "@/assets/svg/Warning.svg";
import useCurrentUserQuery from "@/api/query/useCurrentUserQuery";
import SubscriptionQuery from "@/api/query/useGetSubscription";
import Select from "react-select";
import useOrgSettingsUpdateMutation from "@/api/mutation/useOrgSettingsUpdateMutation";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover";
import { Calendar } from "@/components/ui/calendar";
import { DateRange } from "react-day-picker";
import useAddAvailabilityMutation from "@/api/mutation/useAddAvailabilityMutation";
import useRemoveAvailabilityMutation from "@/api/mutation/useRemoveAvailabilityMutation";
import useGetAvailabilityQuery from "@/api/query/useGetAvailabilityByUserIdQuery";
import useUpdateAvailabilityMutation from "@/api/mutation/useUpdateAvailabilityMutation";
import dateFormater from "@/helperFuntions/dateFormater";
// import useUpdateAvailabilityMutation from "@/api/mutation/useUpdateAvailabilityMutation";
type language = "FR" | "EN";
const OrganisationDetails = () => {
  const location = useLocation();
  const { t, i18n } = useTranslation();
  const TabOptions = [
    {
      id: 1,
      tab: t(`organization_details`),
    },
    {
      id: 3,
      tab: t(`application_settings`),
    },
    {
      id: 2,
      tab: t(`organization_members`),
    },
  ];
  const reactSelectStyle = {
    control: (
      provided: Record<string, unknown>,
      state: { isFocused: boolean }
    ) => ({
      ...provided,
      border: "1px solid #E7E7E7",
      paddingTop: "",
      paddingBottom: "",
      outline: state.isFocused ? "2px solid #299d91" : "0px solid #E7E7E7",
      boxShadow: state.isFocused ? "0px 0px 0px #299d91" : "none",
      "&:hover": {
        outline: state.isFocused ? "1px solid #299d91" : "1px solid #E7E7E7",
        boxShadow: "0px 0px 0px #299d91",
      },
    }),
    option: (
      provided: Record<string, unknown>,
      state: { isSelected: boolean }
    ) => ({
      ...provided,
      color: state.isSelected ? "white" : "black",
      background: state.isSelected ? "#299d91" : "white",
      "&:hover": {
        color: "white",
        background: "#299d9199",
      },
    }),
  };
  const organisationId = useParams().organisationId!;
  const [activeTab, setActiveTab] = useState<number>(1);
  const labelStyle = "font-medium text-base text-gray-450/30";
  const submit = useRef<SubmitRef | null>(null);
  const [userProject, setUserProject] = useState<boolean>(false);
  const [isAvailabilityOpen, setIsAvailabilityOpen] = useState<string>("");
  const [existMember, setExistMember] = useState<boolean>(false);
  const [isAdminConfirmOpenPopUp, setIsAdminConfirmOpenPopUp] =
    useState<boolean>(false);
  const [changed, setChanged] = useState(false);
  const [showSpinner, setShowSpinner] = useState(false);
  const [IsAdmin, setIsAdmin] = useState(false);
  const [selectedIds, setSelectedIds] = useState<string[]>([]);
  const [editData, setEditData] = useState<
    OrganisationType & { userId: string }
  >();
  const [UpdateData, setUpdateData] = useState<
    UserOrganisationType | undefined
  >();
  const [updateMemberData, setUpdateMemberData] = useState<
    UserOrganisationType | undefined
  >();
  const addOrganisationMemberMutation =
    useAddOrganisationMemberMutation(organisationId);
  const addAvailabilityMutation = useAddAvailabilityMutation();
  const removeOrganisationMemberMutation =
    useOrganisationRemoveMemberMutation();
  const updateOrganisationMemberMutation =
    useUpdateOrganisationMemberMutation();
  const [reAssing, setReAssign] = useState(false);
  const [isReasonError, setIsReasonError] = useState(false);
  const [isPopoverOpen, setIsPopoverOpen] = useState(false);
  const [reAssingUser, setReAssignUser] = useState<
    z.infer<typeof reAssginedTaskSchema> & { organisationUserId?: string | string[] }
  >();
  const [isBlockOpenPopUp, setIsBlockOpenPopUp] = useState<
    z.infer<typeof organisationUserBlockUnblockSchema> & { status?: string }
  >();
  const reAssgingTaskMutation = useReAssignTaskMutation();
  const userStatusMutation = useUserStatusMutation();
  const [replacePm, setReplacePm] = useState<string>();
  const [AddPm, setAddPm] = useState<string>();
  const [confirmPopup, setConfirmPopup] = useState<
    "create" | "update" | undefined
  >(undefined);
  const popupRef = useRef<DialogRef>(null);
  const blocker = useBlocker(
    ({ currentLocation, nextLocation }) =>
      changed && currentLocation.pathname !== nextLocation.pathname
  );
  useEffect(() => {
    const handleBeforeUnload = (e: {
      preventDefault: () => void;
      returnValue: string;
    }) => {
      if (changed) {
        e.preventDefault();
        e.returnValue = t("route_block_message"); // Chrome requires returnValue to be set
      }
    };

    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, [changed]);
  const [filteredOrganisationUsers, setFilteredOrganisationUsers] =
    useState<OrganisationResponseType["data"]["userOrganisation"]>();
  const [selectedRange, setSelectedRange] = useState<DateRange | undefined>();
  const [reasonForLeave, setReasonForLeave] = useState<string>("");

  const { validatePlan } = usePlanValidation();
  const addOrgMemberForm = useFormik<
    z.infer<typeof addOrganisationMemberSchema>
  >({
    initialValues: {
      email: UpdateData?.user.email ?? "",
      role: UpdateData?.role ?? UserRoleEnumValue.TEAM_MEMBER,
      language: i18n.language.toUpperCase() as language,
      isAdmin: IsAdmin,
    },
    validationSchema: UpdateData
      ? toFormikValidationSchema(addOrganisationMemberSchema)
      : toFormikValidationSchema(addMemberToOrgSchema),
    onSubmit: (values, helper) => {
      if (UpdateData && UpdateData.user.userId) {
        if (
          !validatePlan(
            IsAdmin
              ? "admin"
              : userRole.some(
                (role) =>
                  role.projectRoleForUser == UserRoleEnumValue.PROJECT_MANAGER
              )
                ? "manager"
                : "member"
          ).valid
        ) {
          return;
        } else {
          updateOrganisationMemberMutation.mutate(
            { ...values, userId: UpdateData?.userOrganisationId },
            {
              onSuccess(data: { data: { message: string } }) {
                refetch();
                closeAddMember();
                setUserProject(false);
                helper.resetForm();
                setUserProject(false);
                setUpdateData(undefined);
                setUserRole([]);
                setCreateUserRole([]);
                toast.success(errorKeyFormate(data.data.message));
              },

              onError(error) {
                if (isAxiosError(error)) {
                  if (
                    error.response?.status === 400 &&
                    error.response.data?.errors &&
                    Array.isArray(error.response?.data.errors)
                  ) {
                    error.response.data.errors.forEach((item) => {
                      helper.setFieldError(item.path[0], item.message);
                    });
                  }
                  if (!Array.isArray(error.response?.data.errors)) {
                    toast.error(
                      errorKeyFormate(error.response?.data.message + ""),
                      errorConfig
                    );
                  }
                }
              },
            }
          );
        }
      } else {
        const roleType = IsAdmin
          ? "admin"
          : createUserRole.some(
            (role) =>
              role.projectRoleForUser === UserRoleEnumValue.PROJECT_MANAGER
          )
            ? "manager"
            : "member";

        if (!validatePlan(roleType).valid) {
          return;
        }
        setShowSpinner(true);
        const isOnlyCollaborator = createUserRole.every(
          (p) => p.projectRoleForUser === UserRoleEnumValue.COLLABORATOR
        );
        addOrganisationMemberMutation.mutate(
          {
            ...values,
            isCollaborator: Boolean(
              isOnlyCollaborator && createUserRole.length
            ),
          },
          {
            onSuccess(data) {
              setUserProject(false);
              if (IsAdmin) {
                toast.success(errorKeyFormate(data.data.message.replace("project manager","admin")), {
                  autoClose: false,
                });                
              }else{
                toast.success(errorKeyFormate(data.data.message));
              }
              refetch();
              setIsOpen(false);
              projectQuery.refetch();
              helper.resetForm();
              setConfirmPopup(undefined);
              setAddPm(
                data.data.data.userOrganisation[0].userOrganisationId ?? ""
              );
              const createData = {
                userOrganisationId:
                  data.data.data.userOrganisation[0].userOrganisationId ?? "",
                data: {
                  arrayOfRoleAndProjectId: createUserRole,
                  isRoleChangePmToTm: replacePm ? true : false,
                  isCollaborator: isOnlyCollaborator,
                },
              };
              if (createUserRole.length) {
                if (IsAdmin) {
                  createData.data.arrayOfRoleAndProjectId.filter(
                    (p) =>
                      p.projectRoleForUser == UserRoleEnumValue.COLLABORATOR
                  );
                }
                assignProjectAndRoleToUserMutation.mutate(createData, {
                  onSuccess(data) {
                    setUserProject(false);
                    toast.success(errorKeyFormate(data.data.message));
                    if (data.data.data.isChargeApplied) {
                      toast.success(
                        errorKeyFormate(data.data.data.additionalMessage),
                        { autoClose: false }
                      );
                    }
                    setShowSpinner(false);

                    projectQuery.refetch();
                    refetch();
                    setUserProject(false);
                    addOrgMemberForm.resetForm();
                    setUpdateData(undefined);
                    setUserRole([]);
                    setCreateUserRole([]);
                    setConfirmPopup(undefined);
                    setAddPm("");
                  },
                  onError(error) {
                    setShowSpinner(false);
                    if (
                      error.response?.data.message.split("!!")[0] ==
                      "Project Manager already exists"
                    ) {
                      setReplacePm(error.response?.data.message.split("!!")[1]);
                      toast.error(
                        errorKeyFormate(
                          error.response?.data.message + ""
                        ).split("!!")[0] + " !!",
                        errorConfig
                      );
                    } else {
                      toast.error(
                        error.response?.data.message == "Unauthorized"
                          ? t(
                            "You are not authorized to edit tasks which are not assigned to you"
                          )
                          : errorKeyFormate(error.response?.data.message + ""),
                        errorConfig
                      );
                    }
                  },
                });
              } else {
                setShowSpinner(false);
              }
            },
            onError(error) {
              if (error) {
                setShowSpinner(false);

                if (
                  error.response?.status === 400 &&
                  error.response.data?.errors &&
                  Array.isArray(error.response?.data.errors)
                ) {
                  error.response.data.errors.forEach((item) => {
                    helper.setFieldError(item.path[0], item.message);
                  });
                }
                if (!Array.isArray(error.response?.data.errors)) {
                  toast.error(
                    errorKeyFormate(error.response?.data.message + ""),
                    errorConfig
                  );
                }
              }
            },
          }
        );
      }
    },
  });

  const toggleUserSelection = (userOrgId: string, isActive: boolean) => {
    if(!isActive) return;
    setSelectedIds((prev) =>
      prev.includes(userOrgId)
        ? prev.filter((id) => id !== userOrgId)
        : [...prev, userOrgId]
    );
  };

  const toggleSelectAll = (
    items: OrganisationResponseType["data"]["userOrganisation"]
  ) => {
    const adminId = data?.data.data.createdByUserId;

    const allUserOrgIds = items
      .filter((i) => i.user.userId !== adminId && i.user.isActive) // exclude admin
      .map((i) => i.userOrganisationId);

    const isAllSelected = allUserOrgIds.every(id => selectedIds.includes(id));

    setSelectedIds(isAllSelected ? [] : allUserOrgIds);
  };

  useEffect(() => {
    if (UpdateData) {
      addOrgMemberForm.setFieldValue(
        "isAdmin",
        filteredOrganisationUsers?.find(
          (u) => u.user.email == UpdateData?.user.email
        )?.role == UserRoleEnumValue.ADMINISTRATOR
      );
    }
  }, [UpdateData, filteredOrganisationUsers]);

  const { data, isLoading, status, refetch } =
    useOrganisationDetailsQuery(organisationId);

  const [organisation, setOrganisation] =
    useState<OrganisationResponseType["data"]>();
  const { user } = useUser();
  const { refetch: AvailabilityRefetch, data: AvailabilityData } =
    useGetAvailabilityQuery(isAvailabilityOpen ?? "");
  const userQuary = useCurrentUserQuery();
  const orgSettingsUpdateMutation = useOrgSettingsUpdateMutation(
    UpdateData?.userOrganisationId ?? ""
  );
  const refetchOrg = () => {
    refetch().then(() => {
      setEditdataFunction();
    });
    user?.userOrganisation[0].organisation.nonWorkingDays;
  };
  const [isOpen, setIsOpen] = useState(false);
  const [filterString, setFilterString] = useDebounce("", 400);
  const [availabilityDataId, setAvailabilityDataId] = useState<string>("");
  const [filterTable, setFilterTable] = useDebounce("", 400);
  const [tabChange, setTabChange] = useState(false);

  const AvailabilityUpdateMutation = useUpdateAvailabilityMutation();

  const navigate = useNavigate();

  useEffect(() => {
    setOrganisation(data?.data.data);
    setFilteredOrganisationUsers(organisation?.userOrganisation ?? []);
    if (location.state?.open) {
      setActiveTab(2);
      setExistMember(false);
      setUserProject(true);
    }
    if (location.state?.tab) {
      setActiveTab(location.state.tab);
    }
    navigate(location.pathname, { replace: true });
  }, [data?.data.data, organisation?.userOrganisation]);

  const [showConfirmDelete, setShowConfirmDelete] = useState("");
  const [resendEmail, setResendEmail] = useState("");
  const [openTable, setOpenTable] = useState<string>();
  const resendInvitationMutation = useResendInvitationMutation();
  const projectQuery = useProjectQuery();
  const [userRole, setUserRole] = useState<
    z.infer<typeof assignProjectAndRoleToUserSchema>["arrayOfRoleAndProjectId"]
  >([]);
  const [createUserRole, setCreateUserRole] = useState<
    z.infer<typeof assignProjectAndRoleToUserSchema>["arrayOfRoleAndProjectId"]
  >([]);
  const assignProjectAndRoleToUserMutation =
    useAssignProjectAndRoleToUserMutation();

  const closeAddMember = () => {
    addOrgMemberForm.setValues({
      email: UpdateData?.user.email ?? "",
      role: UpdateData?.role ?? UserRoleEnumValue.TEAM_MEMBER,
      isAdmin: false,
    });
    setIsOpen(false);
    setUpdateData(undefined);
  };
  const [readOnly, setReadOnly] = useState(true);
  const [filterTableData, setFilterTableData] = useState<Project[]>();
  const [filterAvailableTableData, setFilterAvailableTableData] =
    useState<any>();
  const holiday = user?.userOrganisation[0].organisation.orgHolidays?.map(
    (t) => new Date(t.holidayStartDate)
  );
  const nonWorkingDays = () => {
    const nWd =
      user?.userOrganisation.map((org) => org.organisation.nonWorkingDays) ||
      [];
    const mapDayToNumber = (day: OrgListOfNonWorkingDaysEnum) => {
      switch (day) {
      case "SUN":
        return 0;
      case "MON":
        return 1;
      case "TUE":
        return 2;
      case "WED":
        return 3;
      case "THU":
        return 4;
      case "FRI":
        return 5;
      case "SAT":
        return 6;
      default:
        return 0;
      }
    };
    const result: number[] = [];
    nWd.forEach((days) => {
      days.forEach((day) => {
        result.push(mapDayToNumber(day));
      });
    });
    return result;
  };
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const availabilityRanges = (
    Array.isArray(AvailabilityData?.data?.data)
      ? AvailabilityData.data.data
      : []
  ).flatMap((a) => {
    // ✅ skip disabling for the row currently being edited
    if (a.userAvailabilityId === availabilityDataId) return [];
  
    const start = new Date(a.startDate);
    const end = a.endDate ? new Date(a.endDate) : null;

    if (end) {
      const dates: Date[] = [];
      const current = new Date(start);

      while (current <= end) {
        dates.push(new Date(current)); // clone
        current.setDate(current.getDate() + 1);
      }

      return dates;
    }

    // endDate is null → only disable startDate
    return [start];
  });

  const setEditdataFunction = useCallback(
    (refetchedOrganisation?: OrganisationResponseType["data"]) => {
      const tempOrganisation = refetchedOrganisation ?? organisation;
      const mainAdmin = tempOrganisation?.createdByUserId
      if (tempOrganisation) {
        setEditData({
          country: tempOrganisation.country,
          industry: tempOrganisation.industry,
          organisationId: tempOrganisation.organisationId,
          nonWorkingDays: tempOrganisation.nonWorkingDays,
          status: tempOrganisation.status,
          organisationName: tempOrganisation.organisationName ?? "",
          tenantId: tempOrganisation.tenantId,
          createdByUserId: tempOrganisation.createdByUserId,
          createdAt: tempOrganisation.createdAt,
          updatedAt: tempOrganisation.updatedAt,
          holidayCsvUrl: tempOrganisation.holidayCsvUrl,
          jobTitlesOfOrg: tempOrganisation.jobTitlesOfOrg,
          riskType: tempOrganisation.riskType,
          countryCode:
            tempOrganisation.userOrganisation.find(
              (e) => e?.role == UserRoleEnumValue.ADMINISTRATOR
            )?.user.countryCode ?? "+1",
          phoneNumber:
            tempOrganisation.userOrganisation.find(
              (e) => e?.user.userId === mainAdmin
            )?.user.phoneNumber ?? "",
          userId:
            tempOrganisation.userOrganisation.find(
              (e) => e?.role == UserRoleEnumValue.ADMINISTRATOR
            )?.user.userId ?? "",
          severityTypes: tempOrganisation.severityTypes,
        });
      }
    },
    [organisation]
  );

  useEffect(() => {
    if (!organisation?.userOrganisation) return;
    if (filterString) {
      const stringToFilter = filterString.toLowerCase();
      setFilteredOrganisationUsers(
        organisation.userOrganisation.filter((o) => {
          const fullName = `${o.user.firstName || ""} ${
            o.user.lastName || ""
          }`.toLowerCase();
          return (
            String(o.user.firstName || "")
              .toLowerCase()
              .includes(stringToFilter) ||
            String(o.user.lastName || "")
              .toLowerCase()
              .includes(stringToFilter) ||
            String(o.user.email || "")
              .toLowerCase()
              .includes(stringToFilter) ||
            fullName.includes(stringToFilter)
          );
        })
      );
    } else {
      setFilteredOrganisationUsers(organisation.userOrganisation);
    }
    setEditdataFunction();
  }, [filterString, organisation, setEditdataFunction]);

  useEffect(() => {
    if (filterTable) {
      const stringToFilter = filterTable.toLowerCase();
      setFilterTableData(
        projectQuery.data?.data.data.filter((o) => {
          return (
            String(o.projectName).toLowerCase().includes(stringToFilter) ||
            String(o.projectName).toLowerCase().includes(stringToFilter) ||
            String(o.projectName).toLowerCase().includes(stringToFilter)
          );
        })
      );
    } else {
      setFilterTableData(projectQuery.data?.data.data);
    }
  }, [filterTable, projectQuery.data?.data.data, openTable, isOpen]);

  const currentUserIsAdmin =
    user?.userOrganisation.find((org) => org.organisationId === organisationId)
      ?.role === UserRoleEnumValue.ADMINISTRATOR;

  const handleCheckboxRemoveMember = () => {
    if (!selectedIds.length) return;
    removeOrganisationMemberMutation.mutate(selectedIds, {
      onSuccess(data) {
        setShowConfirmDelete("");
        userQuary.refetch();
        refetch();
        projectQuery.refetch();
        toast.success(data.data.message);
        setReAssignUser(undefined);
        setUserProject(false);
        addOrgMemberForm.resetForm();
        setUpdateData(undefined);
        setUserRole([]);
        setCreateUserRole([]);
        setSelectedIds([]);
      },
      onError(error: any) {
        const errorMessage =
          error.response?.data?.message || "An error occurred";
        toast.error(
          errorKeyFormate(
            typeof errorMessage === "string"
              ? errorMessage
              : errorMessage?.message || errorMessage
          ),
          errorConfig
        );
        if (
          errorMessage === "There are ongoing task that assigned to user!" ||
          errorMessage === "This user has active tasks or projects!"
        ) {
          setReAssign(true);
          setShowConfirmDelete("");
        }
      },
    });
  };

  const handleRemoveMember = (id: string) => {
    removeOrganisationMemberMutation.mutate([id], {
      onSuccess(data) {
        setShowConfirmDelete("");
        userQuary.refetch();
        refetch();
        projectQuery.refetch();
        toast.success(data.data.message);
        setReAssignUser(undefined);
        setUserProject(false);
        addOrgMemberForm.resetForm();
        setUpdateData(undefined);
        setUserRole([]);
        setCreateUserRole([]);
      },
      onError(error: any) {
        const errorMessage =
          error.response?.data?.message || "An error occurred";
        toast.error(
          errorKeyFormate(
            typeof errorMessage === "string"
              ? errorMessage
              : errorMessage?.message || errorMessage
          ),
          errorConfig
        );
        if (
          errorMessage === "There are ongoing task that assigned to user!" ||
          errorMessage === "This user has active tasks or projects!"
        ) {
          setReAssign(true);
          setShowConfirmDelete("");
        }
      },
    });
  };

  const handleReAssign = () => {
    if (reAssingUser) {
      reAssgingTaskMutation.mutate(reAssingUser, {
        onSuccess(data) {
          if (Array.isArray(reAssingUser.organisationUserId)) {
            handleCheckboxRemoveMember()
          } else {
            if(typeof reAssingUser.organisationUserId === "string") {
              handleRemoveMember(reAssingUser.organisationUserId);
            }
          }
          toast.success(data.data.message);
          setReAssignUser(undefined);
          setReAssign(false);
        },
        onError(error) {
          toast.error(
            error.response?.data.message == "Unauthorized"
              ? t(
                "You are not authorized to edit tasks which are not assigned to you"
              )
              : errorKeyFormate(error.response?.data.message + ""),
            errorConfig
          );
        },
      });
    }
  };
  const resend = (id: string) => {
    resendInvitationMutation.mutate(
      { id: id },
      {
        onSuccess(data) {
          toast.success(data.data.message);
          setResendEmail("");
        },
        onError(error) {
          toast.error(
            errorKeyFormate(error.response?.data.message + ""),
            errorConfig
          );
        },
      }
    );
  };

  const userColumnDef: ColumeDef[] = [
    {
      header: "Head",
      key: "head",
      onHeaderRender() {
        const adminUserId = data?.data.data.createdByUserId;

        const allUserOrgIds = (filteredOrganisationUsers ?? [])
          .filter((i) => i.user.userId !== adminUserId && i.user.isActive)
          .map((i) => i.userOrganisationId);

        const allUserIds = (filteredOrganisationUsers ?? [])
          .filter((i) => i.user.userId !== adminUserId && i.user.isActive)
          .map((i) => i.user.userId);

        const isChecked =
          allUserOrgIds.length > 0 &&
          allUserOrgIds.every((id: string) => selectedIds.includes(id));
        return (
          <div>
            <input
              type="checkbox"
              checked={isChecked}
              onChange={() => {
                setReAssignUser((prev) => {
                  if (prev) {
                    return {
                      oldUserId: [...prev.oldUserId, ...allUserIds],
                      newUserId: prev?.newUserId ?? "",
                      organisationUserId: allUserOrgIds,
                    };
                  } else {
                    return {
                      oldUserId: allUserIds,
                      newUserId: "",
                      organisationUserId: allUserOrgIds,
                    };
                  }
                });
                filteredOrganisationUsers &&
                  toggleSelectAll(filteredOrganisationUsers);
              }}
            />
          </div>
        );
      },
      onCellRender(item) {
        const userOrgId = item.userOrganisationId;
        const isAdmin = item.user.userId === data?.data.data.createdByUserId;
        return (
          <input
            type="checkbox"
            disabled={isAdmin || !item.user.isActive}
            checked={selectedIds.includes(userOrgId)}
            onChange={() => {
              if (!isAdmin && item.user.isActive) {
                setReAssignUser((prev) => {
                  if (prev) {
                    return {
                      oldUserId: [...prev.oldUserId, item.user.userId],
                      newUserId: prev?.newUserId ?? "",
                      organisationUserId: prev.organisationUserId && [...prev.organisationUserId, userOrgId],
                    };
                  } else {
                    return {
                      oldUserId: [item.user.userId],
                      newUserId: "",
                      organisationUserId: [userOrgId],
                    };
                  }
                });
                toggleUserSelection(userOrgId, item.user.isActive);
              }
            }}
          />
        );
      },
    },
    {
      header: t("name"),
      key: `username`,
      onCellRender: (item) => (
        <div className="flex items-center gap-1.5 w-full">
          <UserAvatar user={item.user} />
          <div className="text-lg font-normal text-gray-450">
            {item.user.firstName} {item.user.lastName}
          </div>
          {item.role && item.role == UserRoleEnumValue.ADMINISTRATOR ? (
            <div
              className="rounded-md bg-primary-400/50 
            text-[10px] px-1  flex justify-center items-center text-primary-900 font-semibold"
            >
              {t("Admin")}
            </div>
          ) : IsPm(item.user.email) ? (
            <div
              className="rounded-md bg-primary-400/50 
            text-[10px] px-1  flex justify-center items-center text-primary-900 font-semibold"
            >
              {t("PM")}
            </div>
          ) : IsTM(item.user.email) ? (
            <div
              className="rounded-md bg-primary-400/50 
            text-[10px] px-1  flex justify-center items-center text-primary-900 font-semibold"
            >
              {t("TM")}
            </div>
          ) : IsCo(item.user.email) ? (
            <div
              className="rounded-md bg-primary-400/50 
            text-[10px] px-1  flex justify-center items-center text-primary-900 font-semibold"
            >
              {t("CO")}
            </div>
          ) : (
            ""
          )}
        </div>
      ),
    },
    {
      header: t("email"),
      key: `email`,
      onCellRender: (item) => (
        <div className="text-lg text-left w-full font-normal text-gray-450">
          {item.user.email}
        </div>
      ),
    },
    {
      header: t(`job_title`),
      key: `jobTitle`,
      onCellRender: (item) => (
        <div className="text-lg font-normal text-gray-450">
          {item.jobTitle?.replace(/\b\w/g, (char: any) => char.toUpperCase())}
        </div>
      ),
    },
    {
      header: t(`status`),
      key: `status`,
      onCellRender: (item) => (
        <div
          className={`text-center text-white text-lg rounded-md w-fit py-1 px-8 ${
            item.user.status === "ACTIVE" ? "bg-primary-500" : "bg-gray-450"
          }`}
        >
          {item.user.status === "ACTIVE" ? t("Active") : t(`InActive`)}
        </div>
      ),
    },
    {
      header: t(`actions`),
      key: `actions`,
      onCellRender: (userOrg: UserOrganisationType) => (
        <div className="cursor-pointer">
          {
            user?.userOrganisation[0].role && (
              <DropdownMenu>
                <DropdownMenuTrigger
                  asChild
                  disabled={!userOrg.user.isActive}
                  className={`${
                    !userOrg.user.isActive  ? "cursor-not-allowed" : ""
                  }`}
                >
                  <div className="cursor-pointer bg-transparent rounded justify-center items-center gap-px inline-flex">
                    <img src={EditNewTable} alt="No Edit Icon" />
                  </div>
                </DropdownMenuTrigger>
    
                <DropdownMenuContent className="w-fit flex flex-col gap-1">
                  {/* Common items for Administrator */}
                  {userOrg?.role === UserRoleEnumValue.ADMINISTRATOR ? (
                    <>
                      {/* Assign Project */}
                      <DropdownMenuItem
                        onClick={() => {
                          setUserProject(true);
                          setExistMember(true);
                          setUpdateData(userOrg);
                          addOrgMemberForm.setFieldValue("email", userOrg.user.email);
                          setOpenTable(userOrg.userOrganisationId);
                          setUserRoleInfo(userOrg.userOrganisationId);
                        }}
                        className="focus:outline-primary-500"
                      >
                        <img src={User} className="w-4 mr-2" />
                        <span>{t("assign_project")}</span>
                      </DropdownMenuItem>
    
                      {/* Availability */}
                      <DropdownMenuItem
                        onClick={() => {
                          setIsAvailabilityOpen(userOrg.user.userId);
                          setUpdateMemberData(userOrg);
                        }}
                        className="focus:outline-primary-500"
                      >
                        <img src={Absence} className="w-4 mr-2" />
                        <span>{t("availability")}</span>
                      </DropdownMenuItem>
    
                      {/* Resend Email */}
                      {!userOrg.user.isVerified && (
                        <DropdownMenuItem
                          onClick={() => setResendEmail(userOrg.userOrganisationId)}
                        >
                          <ScrollText className="mr-2 h-4 w-4 text-[#44546F]" />
                          <span>{t("resend_email")}</span>
                        </DropdownMenuItem>
                      )}
                    </>
                  ) : (
                    <>
                      {/* Assign Project */}
                      <DropdownMenuItem
                        onClick={() => {
                          setUserProject(true);
                          setExistMember(true);
                          setUpdateData(userOrg);
                          addOrgMemberForm.setFieldValue("email", userOrg.user.email);
                          setOpenTable(userOrg.userOrganisationId);
                          setUserRoleInfo(userOrg.userOrganisationId);
                        }}
                        className="focus:outline-primary-500"
                      >
                        <img src={User} className="w-4 mr-2" />
                        <span>{t("assign_project")}</span>
                      </DropdownMenuItem>
    
                      {/* Availability */}
                      <DropdownMenuItem
                        onClick={() => {
                          setIsAvailabilityOpen(userOrg.user.userId);
                          setUpdateMemberData(userOrg);
                        }}
                        className="focus:outline-primary-500"
                      >
                        <img src={User} className="w-4 mr-2" />
                        <span>{t("availability")}</span>
                      </DropdownMenuItem>
    
                      {/* Resend Email */}
                      {!userOrg.user.isVerified && (
                        <DropdownMenuItem
                          onClick={() => setResendEmail(userOrg.userOrganisationId)}
                        >
                          <ScrollText className="mr-2 h-4 w-4 text-[#44546F]" />
                          <span>{t("resend_email")}</span>
                        </DropdownMenuItem>
                      )}
    
                      {/* Block / Activate */}
                      {userOrg.user.isVerified && (
                        <DropdownMenuItem
                          className="focus:outline-primary-500"
                          onClick={() =>
                            setIsBlockOpenPopUp({
                              userOrganisationId: userOrg.userOrganisationId,
                              organisationId: localStorage.getItem("organisation-id") ?? "",
                              status: userOrg.user.status,
                            })
                          }
                        >
                          <img
                            src={
                              userOrg.user.status !== UserStatusEnumValue.ACTIVE
                                ? Active
                                : UserBlock
                            }
                            className="w-4 mr-2"
                          />
                          <span>
                            {userOrg.user.status === "ACTIVE"
                              ? t("block")
                              : t("activate")}
                          </span>
                        </DropdownMenuItem>
                      )}
    
                      {/* Remove */}
                    </>
                  )}
                  {user && organisation?.createdByUserId === user.userId && userOrg.user.userId !==  user.userId && (
                    <DropdownMenuItem
                      className="focus:outline-primary-500"
                      disabled={selectedIds.length > 0}
                      onClick={() => {
                        setReAssignUser((prev) => ({
                          oldUserId: [userOrg.user.userId],
                          newUserId: prev?.newUserId ?? "",
                          organisationUserId: userOrg.userOrganisationId,
                        }));
                        setShowConfirmDelete(userOrg.userOrganisationId);
                      }}
                    >
                      <img src={TrashCan} className="w-4 mr-2" />
                      <span>{t("remove")}</span>
                    </DropdownMenuItem>
                  )}
                </DropdownMenuContent>
              </DropdownMenu>
            )}
        </div>
      ),
    },
    
  ];
  const columnDef: ColumeDef[] = [
    { header: t("project_name"), key: "projectName" },
    {
      header: t("project_manager"),
      key: "projectName",
      onHeaderRender() {
        return (
          <div>
            <div>{t("project_manager")}</div>
            <input
              type="checkbox"
              onChange={(e) => {
                if (e.target.checked) {
                  const newRoles =
                    filterTableData?.map((p) => ({
                      projectId: p.projectId,
                      projectRoleForUser: UserRoleEnumValue.PROJECT_MANAGER,
                    })) || [];

                  setUserRole(newRoles);
                } else {
                  setUserRole((prev) =>
                    prev.filter(
                      (role) =>
                        !filterTableData?.some(
                          (p) => p.projectId === role.projectId
                        )
                    )
                  );
                }
              }}
              checked={
                userRole.length == filterTableData?.length &&
                userRole.every(
                  (u) =>
                    u.projectRoleForUser == UserRoleEnumValue.PROJECT_MANAGER
                )
              }
              name={UserRoleEnumValue.PROJECT_MANAGER}
            />
          </div>
        );
      },
      onCellRender(data: Project) {
        return (
          <div>
            <input
              type="checkbox"
              onChange={(e) => handleChangeRole(e)}
              name={UserRoleEnumValue.PROJECT_MANAGER}
              checked={
                userRole.find((u) => u.projectId == data.projectId)
                  ?.projectRoleForUser == UserRoleEnumValue.PROJECT_MANAGER
              }
              // disabled={IsAdmin}
              id={data.projectId}
            />
          </div>
        );
      },
    },
    {
      header: t("team_member"),
      key: "projectId",
      onHeaderRender() {
        return (
          <div>
            <div>{t("team_member")}</div>
            <input
              type="checkbox"
              onChange={(e) => {
                if (e.target.checked) {
                  const newRoles =
                    filterTableData?.map((p) => ({
                      projectId: p.projectId,
                      projectRoleForUser: UserRoleEnumValue.TEAM_MEMBER,
                    })) || [];

                  setUserRole(newRoles);
                } else {
                  setUserRole((prev) =>
                    prev.filter(
                      (role) =>
                        !filterTableData?.some(
                          (p) => p.projectId === role.projectId
                        )
                    )
                  );
                }
              }}
              checked={
                userRole.length == filterTableData?.length &&
                userRole.every(
                  (u) => u.projectRoleForUser == UserRoleEnumValue.TEAM_MEMBER
                )
              }
              name={UserRoleEnumValue.TEAM_MEMBER}
            />
          </div>
        );
      },
      onCellRender(data: Project) {
        return (
          <div>
            <input
              type="checkbox"
              onChange={(e) => handleChangeRole(e)}
              name={UserRoleEnumValue.TEAM_MEMBER}
              checked={
                userRole.find((u) => u.projectId == data.projectId)
                  ?.projectRoleForUser == UserRoleEnumValue.TEAM_MEMBER
              }
              // disabled={IsAdmin}
              id={data.projectId}
            />
          </div>
        );
      },
    },
    ...(!addOrgMemberForm.values.isAdmin
      ? [
        {
          header: t("Read Only"),
          key: "readOnly", // Use a unique key instead of "projectName" if this is a separate column
          onHeaderRender() {
            return (
              <div>
                <div>{t("Read Only")}</div>
                <input
                  type="checkbox"
                  onChange={(e) => {
                    if (e.target.checked) {
                      const newRoles =
                          filterTableData?.map((p) => ({
                            projectId: p.projectId,
                            projectRoleForUser: UserRoleEnumValue.COLLABORATOR,
                          })) || [];

                      setUserRole(newRoles);
                    } else {
                      setUserRole((prev) =>
                        prev.filter(
                          (role) =>
                            !filterTableData?.some(
                              (p) => p.projectId === role.projectId
                            )
                        )
                      );
                    }
                  }}
                  checked={
                    userRole.length == filterTableData?.length &&
                      userRole.every(
                        (u) =>
                          u.projectRoleForUser == UserRoleEnumValue.COLLABORATOR
                      )
                  }
                  name={UserRoleEnumValue.COLLABORATOR}
                />
              </div>
            );
          },
          onCellRender(data: Project) {
            const userProjectRole = userRole.find(
              (u) => u.projectId === data.projectId
            )?.projectRoleForUser;

            return (
              <div>
                <input
                  type="checkbox"
                  name={UserRoleEnumValue.COLLABORATOR}
                  checked={userProjectRole === UserRoleEnumValue.COLLABORATOR}
                  disabled={IsAdmin}
                  onChange={(e) => handleChangeRole(e)}
                  id={data.projectId}
                />
              </div>
            );
          },
        },
      ]
      : []),
  ];
  const createUserWithProJectAndRoleColumnDef: ColumeDef[] = [
    { header: t("project_name"), key: "projectName" },
    {
      header: t("project_manager"),
      key: "projectId",
      onHeaderRender() {
        return (
          <div>
            <div>{t("project_manager")}</div>
            <input
              type="checkbox"
              onChange={(e) => {
                if (e.target.checked) {
                  const newRoles =
                    filterTableData?.map((p) => ({
                      projectId: p.projectId,
                      projectRoleForUser: UserRoleEnumValue.PROJECT_MANAGER,
                    })) || [];

                  setCreateUserRole(newRoles);
                } else {
                  setCreateUserRole((prev) =>
                    prev.filter(
                      (role) =>
                        !filterTableData?.some(
                          (p) => p.projectId === role.projectId
                        )
                    )
                  );
                }
              }}
              checked={
                createUserRole.length == filterTableData?.length &&
                createUserRole.every(
                  (u) =>
                    u.projectRoleForUser == UserRoleEnumValue.PROJECT_MANAGER
                )
              }
              name={UserRoleEnumValue.PROJECT_MANAGER}
            />
          </div>
        );
      },
      onCellRender(data: Project) {
        return (
          <div>
            <input
              type="checkbox"
              onChange={(e) => handleChangeCreateUserAndRole(e)}
              name={UserRoleEnumValue.PROJECT_MANAGER}
              checked={
                createUserRole.find((u) => u.projectId == data.projectId)
                  ?.projectRoleForUser == UserRoleEnumValue.PROJECT_MANAGER
              }
              // disabled={IsAdmin}
              id={data.projectId}
            />
          </div>
        );
      },
    },
    {
      header: t("team_member"),
      key: "projectName",
      onHeaderRender() {
        return (
          <div>
            <div>{t("team_member")}</div>
            <input
              type="checkbox"
              onChange={(e) => {
                if (e.target.checked) {
                  const newRoles =
                    filterTableData?.map((p) => ({
                      projectId: p.projectId,
                      projectRoleForUser: UserRoleEnumValue.TEAM_MEMBER,
                    })) || [];

                  setCreateUserRole(newRoles);
                } else {
                  setCreateUserRole((prev) =>
                    prev.filter(
                      (role) =>
                        !filterTableData?.some(
                          (p) => p.projectId === role.projectId
                        )
                    )
                  );
                }
              }}
              checked={
                createUserRole.length == filterTableData?.length &&
                createUserRole.every(
                  (u) => u.projectRoleForUser == UserRoleEnumValue.TEAM_MEMBER
                )
              }
              name={UserRoleEnumValue.TEAM_MEMBER}
            />
          </div>
        );
      },
      onCellRender(data: Project) {
        return (
          <div>
            <input
              type="checkbox"
              onChange={(e) => handleChangeCreateUserAndRole(e)}
              name={UserRoleEnumValue.TEAM_MEMBER}
              checked={
                createUserRole.find((u) => u.projectId == data.projectId)
                  ?.projectRoleForUser == UserRoleEnumValue.TEAM_MEMBER
              }
              // disabled={IsAdmin}
              id={data.projectId}
            />
          </div>
        );
      },
    },
    ...(!addOrgMemberForm.values.isAdmin
      ? [
        {
          header: t("Read Only"),
          key: "projectName",
          onHeaderRender() {
            return (
              <div>
                <div>{t("Read Only")}</div>
                <input
                  type="checkbox"
                  onChange={(e) => {
                    if (e.target.checked) {
                      const newRoles =
                          filterTableData?.map((p) => ({
                            projectId: p.projectId,
                            projectRoleForUser: UserRoleEnumValue.COLLABORATOR,
                          })) || [];

                      setCreateUserRole(newRoles);
                    } else {
                      setCreateUserRole((prev) =>
                        prev.filter(
                          (role) =>
                            !filterTableData?.some(
                              (p) => p.projectId === role.projectId
                            ) &&
                              role.projectRoleForUser ==
                                UserRoleEnumValue.COLLABORATOR
                        )
                      );
                    }
                  }}
                  checked={
                    createUserRole.length == filterTableData?.length &&
                      createUserRole.every(
                        (u) =>
                          u.projectRoleForUser == UserRoleEnumValue.COLLABORATOR
                      )
                  }
                  name={UserRoleEnumValue.COLLABORATOR}
                />
              </div>
            );
          },
          onCellRender(data: Project) {
            return (
              <div>
                <input
                  type="checkbox"
                  onChange={(e) => handleChangeCreateUserAndRole(e)}
                  name={UserRoleEnumValue.COLLABORATOR}
                  checked={
                    createUserRole.find((u) => u.projectId == data.projectId)
                      ?.projectRoleForUser == UserRoleEnumValue.COLLABORATOR
                  }
                  // disabled={IsAdmin}
                  id={data.projectId}
                />
              </div>
            );
          },
        },
      ]
      : []),
  ];

  useEffect(() => {
    if (!isAvailabilityOpen) return;
    AvailabilityRefetch()
      .then((res) => {
        setFilterAvailableTableData(res.data?.data.data);
      })
      .catch((err) => {
        console.error(err);
      });
  }, [isAvailabilityOpen]);

  // Define availability row type
  type AvailabilityRow = {
    firstName: string;
    lastName: string;
    email: string;
    reason: string;
    startDate: Date; // formatted
    endDate?: Date | undefined; // empty for single-day
    userAvailabilityId: string;
  };

  // const formatDate = (d: Date) =>
  //   new Intl.DateTimeFormat(undefined, { day: "2-digit", month: "short", year: "numeric" }).format(d);
  const removeClientMutation = useRemoveAvailabilityMutation();
  const remove = (id: string) => {
    removeClientMutation.mutate(id, {
      onSuccess(data) {
        AvailabilityRefetch()
          .then((res) => {
            setFilterAvailableTableData(res.data?.data.data);
          })
          .catch((err) => {
            console.error(err);
          });
        setIsAdminConfirmOpenPopUp(false);
        toast.success(data.data.message);
      },
      onError(error) {
        toast.error(
          errorKeyFormate(error.response?.data.message + ""),
          errorConfig
        );
        setIsAdminConfirmOpenPopUp(false);
      },
    });
  };

  const isSameDay = (a: Date, b: Date) =>
    a.getFullYear() === b.getFullYear() &&
    a.getMonth() === b.getMonth() &&
    a.getDate() === b.getDate();
  const UTCDateConverter = (date: Date) => {
    return new Date(
      Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), 0, 0, 0)
    );
  };
  // Column definitions
  const [editingReason, setEditingReason] = useState("");
  const [editingStartDate, setEditingStartDate] = useState<Date>();
  const [editingEndDate, setEditingEndDate] = useState<Date | undefined>();
  const formatDate = (date?: Date | null) => {
    if (date) {
      const newDate = new Date(date);
      newDate.setDate(newDate.getDate() + 1);
      return newDate?.toISOString().split("T")[0];
    }
    return undefined;
  };
  const availabilityColumnDef: ColumeDef[] = [
    {
      header: t("Reason"),
      key: "reason",
      onCellRender(data: AvailabilityRow) {
        const isEditing = availabilityDataId === data.userAvailabilityId;
        return isEditing ? (
          <input
            type="text"
            value={editingReason}
            onChange={(e) => setEditingReason(e.target.value)}
            className="border rounded px-2 py-1 w-full"
          />
        ) : (
          <span>{data.reason}</span>
        );
      },
    },
    {
      header: t("start_date"),
      key: "startDate",
      onCellRender(data: AvailabilityRow) {
        const isEditing = availabilityDataId === data.userAvailabilityId;
        return isEditing ? (
          <Popover>
            <PopoverTrigger asChild>
              <div className="px-2 py-1 border border-gray-200  rounded-md">
                <div className="flex w-full gap-2 justify-start items-center text-center">
                  {formatDate(editingStartDate)}
                  <CalendarIcon className="w-4" />
                </div>
              </div>
            </PopoverTrigger>

            <PopoverContent className="p-3">
              <Calendar
                mode="single"
                fromYear={2020}
                toYear={2300}
                captionLayout="dropdown-buttons"
                selected={UTCDateConverter(
                  editingStartDate ? new Date(editingStartDate) : new Date()
                )}
                onSelect={setEditingStartDate}
                defaultMonth={UTCDateConverter(
                  editingStartDate ? new Date(editingStartDate) : new Date()
                )}
                disabled={[
                  { dayOfWeek: nonWorkingDays() },
                  ...(holiday ?? []),
                  ...availabilityRanges,
                ]}
              />
            </PopoverContent>
          </Popover>
        ) : (
          <span>{dateFormater(data.startDate)}</span>
        );
      },
    },
    {
      header: t("end_date"),
      key: "endDate",
      onCellRender(data: AvailabilityRow) {
        const isEditing = availabilityDataId === data.userAvailabilityId;
        return isEditing ? (
          <Popover>
            <PopoverTrigger asChild>
              <div className="px-2 py-1 border border-gray-200  rounded-md">
                <div className="flex w-full gap-2 justify-start items-center text-center">
                  {formatDate(editingEndDate)}
                  <CalendarIcon className="w-4" />
                </div>
              </div>
            </PopoverTrigger>

            <PopoverContent className="p-3">
              <Calendar
                mode="single"
                fromYear={2020}
                toYear={2300}
                captionLayout="dropdown-buttons"
                selected={UTCDateConverter(
                  editingEndDate ? new Date(editingEndDate) : new Date()
                )}
                onSelect={setEditingEndDate}
                defaultMonth={UTCDateConverter(
                  editingEndDate ? new Date(editingEndDate) : new Date()
                )}
                disabled={[
                  { dayOfWeek: nonWorkingDays() },
                  ...(holiday ?? []),
                  ...availabilityRanges,
                  ...(editingStartDate
                    ? [
                      {
                        before: new Date(
                          new Date(editingStartDate).setHours(0, 0, 0, 0)
                        ),
                      },
                    ]
                    : []),
                ]}
              />
            </PopoverContent>
          </Popover>
        ) : (
          <span>{data.endDate ? dateFormater(data.endDate) : dateFormater(data.startDate)}</span>
        );
      },
    },
    {
      header: t("Duration (Days)"),
      key: "duration",
      onCellRender(data: AvailabilityRow) {
        if (!data.startDate ) return <span>-</span>;
        let start: Date;
        let end: Date;
        if (editingStartDate) {
          start = editingStartDate;
        } else {
          start = new Date(data.startDate);
        }
        if (editingEndDate) {
          end = editingEndDate;
        } else {
          end = data.endDate ? new Date(data.endDate) : start;
        }

        const holidays = holiday ?? [];
        const nonWorking = nonWorkingDays();

        const allAvailabilities = Array.isArray(AvailabilityData?.data?.data)
          ? AvailabilityData.data.data
          : AvailabilityData?.data?.data
            ? [AvailabilityData.data.data]
            : [];

        const otherAvailabilities = allAvailabilities
          .filter((a) => a.userAvailabilityId !== data.userAvailabilityId)
          .map((a) => ({
            start: new Date(a.startDate),
            end: a.endDate ? new Date(a.endDate) : new Date(a.startDate),
          }));

        let count = 0;
        const current = new Date(start);

        while (current <= end) {
          const dayOfWeek = current.getDay(); // 0=Sun, 6=Sat
          const dateStr = current.toISOString().split("T")[0];

          // ✅ check holidays safely
          const isHoliday = holidays.some(
            (h: Date) => h.toISOString().split("T")[0] === dateStr
          );
          const isNonWorking = nonWorking.includes(dayOfWeek);

          const isOverlapping = otherAvailabilities.some(
            (range) => current >= range.start && current <= range.end
          );

          if (!isHoliday && !isNonWorking && !isOverlapping) {
            count++;
          }

          current.setDate(current.getDate() + 1);
        }
        
        // ✅ Ensure at least 1 day if single-day leave
        if (start && end&&new Date(start)?.getTime() === new Date(end)?.getTime() && count === 0) {
          count = 1;
        }

        return <span>{count}</span>;
      },
    },
    {
      header: t("action"),
      key: "action",
      onCellRender(data: AvailabilityRow) {
        const isEditing = availabilityDataId === data.userAvailabilityId;

        return (
          <div className="flex gap-5 justify-around items-center">
            {isEditing ? (
              <>
                {/* ✅ Save changes */}
                <CheckIcon
                  size={16}
                  className="cursor-pointer text-green-600"
                  onClick={() => {
                    AvailabilityUpdateMutation.mutate(
                      {
                        userAvailabilityId: data.userAvailabilityId,
                        reason: editingReason,
                        startDate: editingStartDate
                          ? editingStartDate
                          : data.startDate,
                        endDate: editingEndDate,
                        userId: updateMemberData?.user.userId ?? "",
                      },
                      {
                        onSuccess: () => {
                          AvailabilityRefetch()
                            .then((res) => {
                              setFilterAvailableTableData(
                                res.data?.data?.data ?? []
                              );
                              setAvailabilityDataId(""); // exit edit mode
                              setEditingReason("");
                              setEditingStartDate(undefined);
                              setEditingEndDate(undefined);
                            })
                            .catch(console.error);
                        },
                        onError: (error: any) => {
                          console.error(error?.response?.data?.message);
                        },
                      }
                    );
                  }}
                />

                {/* ❌ Cancel editing */}
                <img
                  src={Close}
                  className="cursor-pointer text-red-600 w-3 min-w-3"
                  onClick={() => {
                    setAvailabilityDataId(""); // exit edit mode
                    setEditingReason("");
                    setEditingStartDate(undefined);
                    setEditingEndDate(undefined);
                  }}
                />
              </>
            ) : (
              <>
                {/* ✏️ Edit */}
                <img
                  src={EditNewTable}
                  className="w-5 min-w-5 m-auto cursor-pointer"
                  onClick={() => {
                    setAvailabilityDataId(data.userAvailabilityId);
                    setEditingReason(data.reason ?? "");
                    setEditingStartDate(data.startDate ?? undefined);
                    setEditingEndDate(
                      data.endDate ? new Date(data.endDate) : new Date(data.startDate)
                    );
                  }}
                />

                {/* 🗑 Delete */}
                <img
                  src={TrashCan}
                  className="w-5 min-w-5 m-auto cursor-pointer"
                  onClick={() => {
                    setAvailabilityDataId(data.userAvailabilityId);
                    setIsAdminConfirmOpenPopUp(true);
                  }}
                />
              </>
            )}
          </div>
        );
      },
    },
  ];

  const addSelectedAbsence = () => {
    if (!updateMemberData?.user || !selectedRange?.from) return;

    const { userId } = updateMemberData.user;

    // ✅ Declare Date objects
    const startDate: Date = selectedRange.from;
    const endDate: Date | undefined =
      selectedRange.to && !isSameDay(selectedRange.from, selectedRange.to)
        ? selectedRange.to
        : undefined;

    addAvailabilityMutation.mutate(
      {
        reason: reasonForLeave,
        startDate,
        endDate,
        userId,
      },
      {
        onSuccess() {
          AvailabilityRefetch()
            .then((res) => {
              setReasonForLeave("");
              setFilterAvailableTableData(res.data?.data.data);
            })
            .catch((err) => {
              console.error(err);
            });
        },
      }
    );
    setIsPopoverOpen(false);
    setSelectedRange(undefined);
  };

  const handleChangeRole = (e: ChangeEvent<HTMLInputElement>) => {
    const id = e.target.id;
    const role = e.target.name as keyof typeof UserRoleEnumValue;
    const checked = e.target.checked;
    if (userRole?.some((pr) => id == pr.projectId)) {
      setUserRole(
        userRole.filter((e) => {
          let temp:
            | z.infer<
                typeof assignProjectAndRoleToUserSchema
              >["arrayOfRoleAndProjectId"][0]
            | null = e;
          if (e.projectId == id && checked) {
            temp.projectRoleForUser = role;
          } else if (!checked && e.projectId == id) {
            temp = null;
          }
          if (temp) return temp;
        })
      );
    } else {
      setUserRole((prev) => {
        if (prev && prev.length) {
          return [...prev, { projectId: id, projectRoleForUser: role }];
        } else {
          return [{ projectId: id, projectRoleForUser: role }];
        }
      });
    }
  };

  const handleSubmit = () => {
    submit.current?.callSubmit();
  };

  const handleChangeCreateUserAndRole = (e: ChangeEvent<HTMLInputElement>) => {
    const id = e.target.id;
    const role = e.target.name as keyof typeof UserRoleEnumValue;
    const checked = e.target.checked;
    if (createUserRole?.some((pr) => id == pr.projectId)) {
      setCreateUserRole(
        createUserRole.filter((e) => {
          let temp:
            | z.infer<
                typeof assignProjectAndRoleToUserSchema
              >["arrayOfRoleAndProjectId"][0]
            | null = e;
          if (e.projectId == id && checked) {
            temp.projectRoleForUser = role;
          } else if (!checked && e.projectId == id) {
            temp = null;
          }
          if (temp) return temp;
        })
      );
    } else {
      setCreateUserRole((prev) => {
        if (prev && prev.length) {
          return [...prev, { projectId: id, projectRoleForUser: role }];
        } else {
          return [{ projectId: id, projectRoleForUser: role }];
        }
      });
    }
  };
  function shouldShowConfirmPM(
    userRole: {
      projectRoleForUser:
        | "ADMINISTRATOR"
        | "PROJECT_MANAGER"
        | "TEAM_MEMBER"
        | "COLLABORATOR";
      projectId: string;
    }[],
    temp:
      | (
          | {
              projectId: string;
              projectRoleForUser: string | null;
            }
          | {
              projectId: string;
              projectRoleForUser?: undefined;
            }
        )[]
      | undefined,
    UpdateData: UserOrganisationType | undefined
  ) {
    const alreadyPM = temp?.some(
      (role) => role.projectRoleForUser === UserRoleEnumValue.PROJECT_MANAGER
    );
    const currentIsAdmin = UpdateData?.role === UserRoleEnumValue.ADMINISTRATOR;

    // 1. If user is already PM or Admin, NO popup
    if (alreadyPM || currentIsAdmin) return false;

    // 2. If after assigning, user has NO ROLE in any project, NO popup
    const hasAnyRole = userRole?.some((t) => !!t.projectRoleForUser);
    if (!hasAnyRole) return false;

    // 3. If user becomes PM first time
    const becamePM = userRole?.some((t) => {
      const previousRole = temp?.find(
        (u) => u.projectId === t.projectId
      )?.projectRoleForUser;
      const currentRole = t.projectRoleForUser;

      return (
        currentRole === UserRoleEnumValue.PROJECT_MANAGER &&
        previousRole !== UserRoleEnumValue.PROJECT_MANAGER
      );
    });

    return becamePM;
  }

  const submitAssignProjectAndRole = async (
    showConfirm = true,
    isRoleReplace = false
  ) => {
    const temp = projectQuery.data?.data.data.map((d) => {
      const user = d.assignedUsers.find(
        (u) => u.user.userOrganisation[0].userOrganisationId == openTable
      );

      if (user) {
        return {
          projectId: d.projectId,
          projectRoleForUser: user?.projectRole,
        };
      } else {
        return {
          projectId: d.projectId,
        };
      }
    });
    if (
      userRole.some(
        (role) => role.projectRoleForUser == UserRoleEnumValue.PROJECT_MANAGER
      )
    ) {
      const userId = organisation?.userOrganisation.find(
        (u) => u.userOrganisationId == openTable
      )?.user.userId;
      if (!validatePlan("manager", userId).valid) {
        return;
      }
      // if(){
      //   setConfirmPopup(true);
      //   return;
      // }
    }
    const currentIsAdmin = UpdateData?.role === UserRoleEnumValue.ADMINISTRATOR;
    const formIsAdmin = addOrgMemberForm.values.isAdmin;
    // Only call API if admin status changed
    if (!currentIsAdmin && formIsAdmin && showConfirm) {
        setConfirmPopup("update");
        return;
    }
    if (currentIsAdmin !== formIsAdmin) {
      setShowSpinner(true);
      await orgSettingsUpdateMutation.mutateAsync(
        { isAdmin: formIsAdmin },
        {

          onSuccess(data) {
            console.log(data.data.message.replace("project manager","admin"));
            
            refetchOrg();
            setShowSpinner(false);
            setConfirmPopup(undefined);
            toast.success(errorKeyFormate(data.data.message.replace("project manager","admin")), {
              autoClose: false,
            });
          },
          onError(error) {
            setShowSpinner(false);
            toast.error(
              error.response?.data.message === "Unauthorized"
                ? t(
                  "You are not authorized to edit tasks which are not assigned to you"
                )
                : errorKeyFormate(error.response?.data.message + ""),
              errorConfig
            );
          },
        }
      );
    }
    const shouldSetConfirmPopup = shouldShowConfirmPM(
      userRole,
      temp,
      UpdateData
    );

    if (shouldSetConfirmPopup && showConfirm) {
      setConfirmPopup("update");
      return;
    }
    if (
      JSON.stringify(temp) !== JSON.stringify(userRole) ||
      currentIsAdmin !== formIsAdmin
    ) {
      if (
        userRole.some(
          (role) => role.projectRoleForUser == UserRoleEnumValue.PROJECT_MANAGER
        )
      ) {
        const userId = organisation?.userOrganisation.find(
          (u) => u.userOrganisationId == openTable
        )?.user.userId;
        if (!validatePlan("manager", userId).valid) {
          return;
        }
        // if(){
        //   setConfirmPopup(true);
        //   return;
        // }
      }
      const isRoleChangePmToTm = temp?.some((prev) => {
        const updated = userRole.find((u) => u.projectId === prev.projectId);
        if (!updated) return false;

        return (
          prev.projectRoleForUser === UserRoleEnumValue.PROJECT_MANAGER &&
          (updated.projectRoleForUser === UserRoleEnumValue.TEAM_MEMBER ||
            updated.projectRoleForUser === UserRoleEnumValue.COLLABORATOR)
        );
      });
      const assignData = {
        userOrganisationId: AddPm ? AddPm : openTable ?? "",
        data: {
          arrayOfRoleAndProjectId: createUserRole.length
            ? createUserRole
            : userRole.filter((d) => {
              if (!d.projectRoleForUser) return false;
              if (
                IsAdmin &&
                  d.projectRoleForUser === UserRoleEnumValue.COLLABORATOR
              )
                return false;
              return true;
            }),
          isCollaborator: false,
          isRoleChangePmToTm: Boolean(isRoleReplace || isRoleChangePmToTm),
        },
      };

      setShowSpinner(true);

      assignProjectAndRoleToUserMutation.mutate(assignData, {
        onSuccess(data) {
          toast.success(data.data.message);
          if (data.data.data.isChargeApplied) {
            toast.success(errorKeyFormate(data.data.data.additionalMessage), {
              autoClose: false,
            });
          }
          projectQuery.refetch();
          setReplacePm(undefined);
          setOpenTable(undefined);
          setConfirmPopup(undefined);
          setShowSpinner(false);
          setAddPm("");
        },
        onError(error) {
          setShowSpinner(false);
          if (
            error.response?.data.message.split("!!")[0] ==
            "Project Manager already exists"
          ) {
            setReplacePm(error.response?.data.message.split("!!")[1]);
            toast.error(
              errorKeyFormate(error.response?.data.message + "").split(
                "!!"
              )[0] + " !!",
              errorConfig
            );
          } else {
            toast.error(
              error.response?.data.message == "Unauthorized"
                ? t(
                  "You are not authorized to edit tasks which are not assigned to you"
                )
                : errorKeyFormate(error.response?.data.message + ""),
              errorConfig
            );
          }
        },
      });
    }
    setUserProject(false);
  };
  const handleBlock = () => {
    if (isBlockOpenPopUp) {
      userStatusMutation.mutate(isBlockOpenPopUp, {
        onSuccess(data) {
          toast.success(data.data.message);
          setIsBlockOpenPopUp(undefined);
          refetch();
          refetchOrg();
        },
        onError(error) {
          toast.error(
            errorKeyFormate(error.response?.data.message + ""),
            errorConfig
          );
        },
      });
    }
  };
  const setUserRoleInfo = (id: string) => {
    if (id) {
      const temp = projectQuery.data?.data.data.map((d) => {
        const user = d.assignedUsers.find(
          (u) => u.user.userOrganisation[0].userOrganisationId == id
        );
        if (user) {
          return {
            projectId: d.projectId,
            projectRoleForUser: user?.projectRole,
          };
        } else {
          return {
            projectId: d.projectId,
          };
        }
      });
      if (temp) {
        setUserRole(
          temp as z.infer<
            typeof assignProjectAndRoleToUserSchema
          >["arrayOfRoleAndProjectId"]
        );
      }
    }
  };

  // unstable_usePrompt({
  //   message: "Are you sure?",
  //   when: ({ currentLocation, nextLocation }) =>
  //     changed && currentLocation.pathname !== nextLocation.pathname,
  // });

  const subscriptionQuery = SubscriptionQuery();

  const getSubscriptionChargeMessage = () => {
    const subscription = subscriptionQuery.data?.data.data;
    // comment out if you want to activate free trail feature 
    // if (!subscription && user?.subscription?.customerId === "FREE_TRIAL") {
    //   return "User is deactivated after 14 days free trial";
    // }
    // if (!subscription || !user) return null;  /*remove if you dont want a free trial feature*/

    const isYearly =
      user?.subscription?.billingCycle === BillingCycleSchema.YEAR;
    const basePrice = isYearly ? 290 : 29;

    const discount = subscription?.discount?.coupon;
    let discountedPrice = basePrice;
    let discountDuration = "";
    let isForever = false;

    if (discount) {
      if (discount.percent_off) {
        discountedPrice = basePrice - (basePrice * discount.percent_off) / 100;
      } else if (discount.amount_off) {
        discountedPrice = Math.max(basePrice - discount.amount_off / 100, 0);
      }

      if (discount.duration_in_months) {
        discountDuration = t("forFirstNPeriods", {
          count: discount.duration_in_months,
        });
      } else if (discount.duration === "forever") {
        isForever = true;
      }
    }

    const finalPrice = isYearly ? 290 : 29;

    return discount
      ? isForever
        ? t("subscriptionChargeForeverDiscount", {
          amount: discountedPrice.toFixed(2),
          period: isYearly ? t("year") : t("month"),
        })
        : t("subscriptionChargeWithDiscount", {
          amount: discountedPrice.toFixed(2),
          discountDuration: discountDuration,
          finalPrice: finalPrice.toFixed(2),
          period: isYearly ? t("year") : t("month"),
        })
      : t("subscriptionChargeNoDiscount", {
        finalPrice: finalPrice.toFixed(2),
        period: isYearly ? t("year") : t("month"),
      });
  };
  useEffect(() => {
    if (addOrgMemberForm.errors.email) {
      if (popupRef.current?.modalElement?.scrollHeight) {
        popupRef.current?.modalElement?.scrollTo({
          top: 0,
          behavior: "smooth",
        });
      }
    }
  }, [addOrgMemberForm]);

  const handleMemberAction = async () => {
    await addOrgMemberForm.validateForm();
    if (!addOrgMemberForm.values.email) return;
    if (!existMember) {
      const isEnterpriseWithRoles =
        user?.subscription?.planType === PlanTypeEnumSchema.ENTERPRISE &&
        createUserRole?.length > 0 &&
        !createUserRole.every(
          (u) =>
            u.projectRoleForUser === UserRoleEnumValue.TEAM_MEMBER ||
            u.projectRoleForUser === UserRoleEnumValue.COLLABORATOR
        );
      if (
        IsAdmin &&
        user?.subscription?.planType === PlanTypeEnumSchema.ENTERPRISE
      ) {
        setConfirmPopup("create");
        return;
      }
      if (isEnterpriseWithRoles && !IsAdmin) {
        setConfirmPopup("create");
      } else {
        addOrgMemberForm.submitForm();
      }
    } else {
      submitAssignProjectAndRole();
    }
  };
  const [validationError, setvalidationError] = useState("");
  const OrganisationNoPopupFormMemories = useMemo(
    () => (
      <OrganisationNoPopupForm
        ref={submit}
        setvalidationError={setvalidationError}
        editData={editData}
        viewOnly={
          user?.userOrganisation[0].role == UserRoleEnumValue.ADMINISTRATOR
            ? currentUserIsAdmin && readOnly
            : true
        }
        activeTab={activeTab}
        refetch={refetchOrg}
        valueChange={setChanged}
        key={JSON.stringify(editData)}
        close={() => {
          refetchOrg();
          setReadOnly(!readOnly);
        }}
      />
    ),
    [activeTab, currentUserIsAdmin, readOnly, editData]
  );
  if (status === "error")
    return (
      <div className="text-red-500 text-lg text-center">
        Organisation with id "{organisationId}" not found
      </div>
    );
  function getRole(role: keyof typeof UserRoleEnumValue): string {
    const formattedRole = role
      .toLowerCase()
      .replace("_", " ")
      .replace(/\b\w/g, (char) => char.toUpperCase()); // capitalize each word
    return formattedRole;
  }

  const roleFilter = (role: keyof typeof UserRoleEnumValue | null) => {
    if (!role) {
      setFilteredOrganisationUsers(organisation?.userOrganisation);
      return;
    }
    if (role == UserRoleEnumValue.ADMINISTRATOR) {
      setFilteredOrganisationUsers(
        organisation?.userOrganisation.filter((u) => u.role)
      );
    } else {
      const email: string[] = [];
      projectQuery.data?.data.data.forEach((p) => {
        return p.assignedUsers.forEach((u) => {
          if (u.projectRole == role && !email.includes(u.user.email)) {
            email.push(u.user.email);
          }
        });
      });
      const roleUser = organisation?.userOrganisation.filter((e) => {
        return email.includes(e.user.email);
      });
      setFilteredOrganisationUsers(roleUser);
    }
  };

  const IsPm = (email: string) => {
    return projectQuery.data?.data.data.some((p) => {
      return p.assignedUsers.some((u) => {
        if (
          u.projectRole == UserRoleEnumValue.PROJECT_MANAGER &&
          email == u.user.email
        ) {
          return true;
        }
        return false;
      });
    });
  };
  const IsTM = (email: string) => {
    return projectQuery.data?.data.data.some((p) => {
      return p.assignedUsers.some((u) => {
        if (
          u.projectRole == UserRoleEnumValue.TEAM_MEMBER &&
          email == u.user.email
        ) {
          return true;
        }
        return false;
      });
    });
  };
  const IsCo = (email: string) => {
    return projectQuery.data?.data.data.some((p) => {
      return p.assignedUsers.some((u) => {
        if (
          u.projectRole == UserRoleEnumValue.COLLABORATOR &&
          email == u.user.email
        ) {
          return true;
        }
        return false;
      });
    });
  };
  
  return (
    <div className="p-5 h-full overflow-auto">
      {isLoading || showSpinner &&<Loader className="absolute h-full w-full z-[100] top-0 left-0 " />}
      {projectQuery.isFetching ||
        (projectQuery.isRefetching && (
          <Loader className="absolute h-full w-full top-0 left-0 " />
        ))}
      {showSpinner ||
        removeOrganisationMemberMutation.isPending ||
        (reAssgingTaskMutation.isPending && (
          <Loader className="absolute h-full w-full top-0 left-0  z-[99]" />
        ))}

      <div className="flex flex-row-reverse w-full justify-between">
        <div className="flex gap-4 justify-end items-center h-full">
          {currentUserIsAdmin && (activeTab === 1 || activeTab === 3) ? (
            <div className="ml-auto flex gap-3 items-center">
              {validationError && !readOnly && (
                <span className="text-red-500 text-xs">
                  {t(validationError)}
                </span>
              )}
              {readOnly ? (
                <Button
                  size={"sm"}
                  variant={"primary"}
                  className={` text-white`}
                  onClick={() => setReadOnly(!readOnly)}
                >
                  <div className="flex gap-2 items-center">
                    <img src={EditPen} /> {t("edit")}
                  </div>
                </Button>
              ) : (
                <Button
                  size={"sm"}
                  variant={"default"}
                  className={`bg-red-500 text-white`}
                  onClick={() => {
                    setEditdataFunction(data?.data.data);
                    setReadOnly(!readOnly);
                  }}
                >
                  {t("cancel")}
                </Button>
              )}
            </div>
          ) : (
            ""
          )}
          {activeTab === 1 || activeTab === 3 ? (
            <>
              {!readOnly && (
                <Button
                  children={t(`update`)}
                  variant={"primary"}
                  className={"text-white w-24"}
                  onClick={handleSubmit}
                />
              )}
            </>
          ) : (
            ""
          )}
        </div>
        <div className="flex gap-10 items-center text-gray-450 text-base md:text-lg font-bold my-3.5 cursor-pointer border-b">
          {TabOptions &&
            TabOptions.map((item, index) => (
              <div
                key={index}
                className={`${
                  activeTab === item.id &&
                  "text-primary-500 underline underline-offset-8"
                } ${
                  item.id == 1 && validationError && !readOnly
                    ? "text-red-500"
                    : "text-gray-450"
                } `}
                onClick={() => {
                  if ((activeTab == 1 || activeTab == 3) && changed) {
                    setTabChange(true);
                  } else {
                    setActiveTab(item.id);
                    setReadOnly(true);
                    setChanged(false);
                  }
                }}
              >
                {item.tab}
              </div>
            ))}
        </div>
      </div>
      {activeTab == 2 && (
        <div className="flex justify-end w-full gap-2 mb-2">
          <div className="flex gap-2 items-center">
            <Select
              name="search filter"
              options={[
                { label: "Select role", value: null },
                ...Object.values(UserRoleEnumValue).map((e) => {
                  return { label: t(getRole(e)), value: e };
                }),
              ]}
              className=" w-48"
              styles={reactSelectStyle}
              onChange={(event) => roleFilter(event ? event?.value : null)}
            />
            <InputText
              name="search filter"
              id="search-filter"
              placeholder={t("filter_by_name_and_email")}
              className="mt-0 h-auto sm:w-fit max-w-full"
              onChange={(event) => setFilterString(event.target.value)}
            />
          </div>
          <div className="add">
            {user?.userOrganisation[0].role ==
              UserRoleEnumValue.ADMINISTRATOR && (
              <Button
                variant={"primary"}
                children={t(`add_member`)}
                className="text-white"
                onClick={() => {
                  if (!validatePlan("member").valid) {
                    return;
                  }
                  setExistMember(false);
                  setUserProject(true);
                  setIsAdmin(false);
                  setUpdateData(undefined);
                  addOrgMemberForm.resetForm();
                }}
              />
            )}
          </div>
          {selectedIds.length > 0 && (
            <Button
              variant={"destructive"}
              children={t(`delete_members`)}
              onClick={() => {
                setShowConfirmDelete("show");
              }}
            />
          )}
        </div>
      )}
      <div className={`${activeTab === 1 || activeTab === 3 ? "" : "hidden"}`}>
        {OrganisationNoPopupFormMemories}
      </div>

      {activeTab == 2 && (
        <Table
          columnDef={userColumnDef}
          data={filteredOrganisationUsers ?? []}
          className="!p-0 !h-[85%]"
          onRowClassName={(data) => {
            return !data.user.isActive
              ? "opacity-70 bg-gray-400/30  cursor-not-allowed"
              : "";
          }}
        />
      )}

      <Dialog
        isOpen={userProject}
        modalClass="rounded-md w-1/2"
        onClose={() => {
          setUserProject(false), addOrgMemberForm.resetForm();
          setUpdateData(undefined);
        }}
        ref={popupRef}
      >
        <div className="p-4">
          <div className="flex justify-end items-center">
            <img
              className="select-none cursor-pointer"
              src={Close}
              alt="No ImageFound"
              onClick={() => {
                setUserProject(false), addOrgMemberForm.resetForm();
                setUpdateData(undefined);
                setUserRole([]);
                setCreateUserRole([]);
              }}
            />
          </div>
          <div className={`text-left w-full flex-col`}>
            <div>
              <label className={labelStyle + "mb-0 text-lg !font-bold"}>
                {t("enter_email")}
              </label>
            </div>
            <InputEmail
              name="email"
              id="email"
              placeholder="Enter member email"
              className="w-96 mt-0.5"
              value={addOrgMemberForm.values.email}
              onChange={(e) => {
                addOrgMemberForm.handleChange(e);
              }}
              onBlur={(e) => {
                if (
                  data?.data.data.userOrganisation.find(
                    (u) => u.user.email.trim() === e.target.value.trim()
                  )
                ) {
                  addOrgMemberForm.setFieldError(
                    "email",
                    "User already exists with this email!"
                  );
                }
              }}
              disabled={existMember ? true : false}
            />
            <div>
              {addOrgMemberForm.errors.email && (
                <ErrorMessage>{t(addOrgMemberForm.errors.email)}</ErrorMessage>
              )}
            </div>
          </div>
          <div>
            <div className="flex gap-2 items-center mt-2">
              <label htmlFor="">{t("Is Admin")}</label>
              <input
                type="checkbox"
                key={addOrgMemberForm.values.isAdmin + ""}
                checked={addOrgMemberForm.values.isAdmin}
                onChange={(e) => {
                  addOrgMemberForm.setFieldValue("isAdmin", e.target.checked);
                  setIsAdmin(e.target.checked);
                }}
                disabled={
                  UpdateData?.user.userId ==
                    user?.userOrganisation[0].organisation.createdByUserId ||
                  user?.userId == UpdateData?.user.userId
                }
              />
            </div>
            <label htmlFor="" className="text-xs">
              {t("Is Admin description")}
            </label>
          </div>
          <div className="text-lg font-normal mt-3.5">
            {t("assign_to_projects")}
          </div>
          <div className="w-full">
            <InputText
              name="search filter"
              id="search-filter"
              placeholder="Find Project by Name"
              onChange={(event) => setFilterTable(event.target.value)}
            />
          </div>
          <div className="mt-3.5 w-full">
            <Table
              columnDef={
                existMember ? columnDef : createUserWithProJectAndRoleColumnDef
              }
              data={filterTableData ?? []}
              className="!p-0"
            />
          </div>
          <div className="flex items-center gap-5 justify-end">
            <Button
              size={"sm"}
              variant={"default"}
              className={`bg-red-500 text-white`}
              onClick={() => {
                setUserProject(false), addOrgMemberForm.resetForm();
                setUpdateData(undefined);
                setUserRole([]);
                setCreateUserRole([]);
              }}
            >
              {t("cancel")}
            </Button>
            <Button
              size={"sm"}
              variant={"primary"}
              className={"text-white"}
              disabled={!addOrgMemberForm.isValid}
              onClick={() => {
                if (
                  user?.subscription?.customerId ===
                  ExtendPlanTypeEnumSchema.FREE_TRIAL
                ) {
                  if(existMember) {
                    submitAssignProjectAndRole(false);
                  } else {
                    addOrgMemberForm.submitForm();
                  }
                } else {
                  handleMemberAction();
                }
              }}
            >
              {t("save")}
            </Button>
          </div>
        </div>
      </Dialog>
      <Dialog
        isOpen={Boolean(showConfirmDelete)}
        onClose={() => {}}
        modalClass="rounded-lg"
      >
        <div className="flex flex-col gap-2 p-6 ">
          <img src={TrashCan} className="w-12 m-auto" />{" "}
          {t("common_delete_message")}
          <div className="flex gap-2 ml-auto">
            <Button
              variant={"outline"}
              isLoading={removeOrganisationMemberMutation.isPending}
              disabled={removeOrganisationMemberMutation.isPending}
              onClick={() => setShowConfirmDelete("")}
            >
              {t("cancel")}
            </Button>
            <Button
              variant={"primary"}
              className={"text-white"}
              // onClick={removeTask}
              isLoading={removeOrganisationMemberMutation.isPending}
              disabled={removeOrganisationMemberMutation.isPending}
              onClick={() => {
                if (selectedIds && selectedIds.length > 0) {
                  handleCheckboxRemoveMember();
                } else {
                  handleRemoveMember(showConfirmDelete);
                }
              }}
            >
              {t("delete")}
            </Button>
          </div>
        </div>
      </Dialog>
      <Dialog
        isOpen={Boolean(replacePm)}
        onClose={() => {}}
        modalClass="rounded-lg"
      >
        <div className="flex flex-col gap-4 p-6 w-96 text-center">
          <img
            src={NewEditIcon}
            className="w-12 m-auto"
            onClick={() => setReplacePm(undefined)}
          />{" "}
          {errorKeyFormate(
            `Another project manager is already assigned to these projects {{${replacePm
              ?.replace(",", ", ")
              .replace("{{", "")
              .replace(
                "}}",
                ""
              )} }} Do you want to change him to a team member and assign the new project manager`
          )}
          <div className="flex gap-2 ml-auto">
            <Button
              variant={"outline"}
              isLoading={removeOrganisationMemberMutation.isPending}
              disabled={removeOrganisationMemberMutation.isPending}
              onClick={() => {
                setReplacePm(undefined),
                  refetch(),
                  projectQuery.refetch(),
                  setOpenTable("");
              }}
            >
              {t("cancel")}
            </Button>
            <Button
              variant={"primary"}
              // onClick={removeTask}.
              className={"text-white"}
              isLoading={removeOrganisationMemberMutation.isPending}
              disabled={removeOrganisationMemberMutation.isPending}
              onClick={() => {
                submitAssignProjectAndRole(false, true);
              }}
            >
              {t("confirm")}
            </Button>
          </div>
        </div>
      </Dialog>
      <Dialog
        isOpen={Boolean(isBlockOpenPopUp?.organisationId)}
        onClose={() => {}}
        modalClass="rounded-lg"
      >
        <div className="flex flex-col gap-2 p-6 ">
          <img
            src={
              isBlockOpenPopUp?.status !== UserStatusEnumValue.ACTIVE
                ? Active
                : UserBlock
            }
            className="w-12 m-auto"
          />{" "}
          {t("Are you sure you want to")}{" "}
          {isBlockOpenPopUp?.status == UserStatusEnumValue.ACTIVE
            ? t("Block")
            : t("Activate")}{" "}
          ?
          <div className="flex gap-2 ml-auto">
            <Button
              variant={"outline"}
              onClick={() => setIsBlockOpenPopUp(undefined)}
            >
              {t("cancel")}
            </Button>
            <Button
              variant={"primary"}
              className={"text-white"}
              onClick={() => {
                handleBlock();
              }}
            >
              {isBlockOpenPopUp?.status == UserStatusEnumValue.ACTIVE
                ? t("Block")
                : t("Activate")}
            </Button>
          </div>
        </div>
      </Dialog>
      <Dialog
        isOpen={Boolean(resendEmail)}
        onClose={() => {}}
        modalClass="rounded-lg"
      >
        <div className="flex flex-col gap-2 p-6 ">
          <div className="flex justify-center m-auto w-14 items-center h-14 p-2 rounded-full">
            <img src={MailResendIcon} className="w-14  m-auto " />
          </div>
          {t("Are you sure you want to Resend invitation ?")}
          <div className="flex gap-2 ml-auto">
            <Button variant={"outline"} onClick={() => setResendEmail("")}>
              {t("cancel")}
            </Button>
            <Button
              variant={"primary"}
              className={"text-white"}
              onClick={() => {
                resend(resendEmail);
              }}
            >
              {t("Resend")}
              <img src={SendIcon} className="w-3 ml-2" />
            </Button>
          </div>
        </div>
      </Dialog>
      <Dialog
        isOpen={Boolean(confirmPopup)}
        onClose={() => {}}
        modalClass="rounded-lg w-3/12"
      >
        <div className="flex flex-col gap-2 p-6 text-center">
          <img src={Warning} className="w-12 m-auto opacity-70" />{" "}
          {getSubscriptionChargeMessage()}
          <div className="flex gap-2 ml-auto mt-4">
            <Button
              variant={"outline"}
              onClick={() => setConfirmPopup(undefined)}
            >
              {t("cancel")}
            </Button>
            <Button
              variant={"primary"}
              className={"text-white"}
              onClick={() => {
                setConfirmPopup(undefined);
                confirmPopup == "create"
                  ? addOrgMemberForm.submitForm()
                  : submitAssignProjectAndRole(false);
              }}
            >
              {t("confirm")}
            </Button>
          </div>
        </div>
      </Dialog>
      <Dialog
        isOpen={reAssing}
        onClose={() => closeAddMember()}
        hasEscClose={true}
        modalClass="sm:rounded-lg p-4 h-full md:h-auto w-full max-w-md"
      >
        <div className="flex flex-col">
          <div className="text-lg font-semibold text-gray-600">
            {t("Task reassign to other user")}
          </div>
          <div className="border rounded-md border-gray-100 mt-3 ">
            {organisation?.userOrganisation
              ?.filter(
                (userorg) =>
                  !reAssingUser?.oldUserId.some(
                    (id) => id === userorg.user.userId
                  ) && userorg.user.isActive
              )
              .map((userOrg) => (
                <>
                  <div
                    key={userOrg.userOrganisationId}
                    className="flex flex-wrap md:flex-nowrap items-center px-2 py-1.5 sm:px-5 sm:py-3 gap-9 hover:bg-slate-50"
                    onClick={() => {
                      setReAssignUser((prev) => ({
                        oldUserId: prev?.oldUserId ?? [""],
                        newUserId: userOrg.user.userId,
                        organisationUserId: prev?.organisationUserId ?? "",
                      }));
                    }}
                  >
                    <div
                      className={`flex w-full sm:w-auto gap-2 items-center grow ${
                        currentUserIsAdmin ? "cursor-pointer" : ""
                      }`}
                    >
                      <div className="relative">
                        <CheckIcon
                          className={cn(
                            "ml-auto w-full h-full rounded-full text-base absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 z-50 bg-slate-200/70 ",
                            userOrg.user.userId === reAssingUser?.newUserId
                              ? "opacity-100"
                              : "opacity-0"
                          )}
                        />
                        <UserAvatar
                          user={userOrg.user}
                          className="min-w-8"
                        ></UserAvatar>
                      </div>
                      <div className="text-sm">
                        <div className="text-slate-800 font-medium">
                          {userOrg.user.firstName ?? ""}{" "}
                          {userOrg.user.lastName ?? ""}
                        </div>
                        <div className="text-gray-400">
                          {userOrg.user.email}
                        </div>
                      </div>
                      <div className="w-full h-full">
                        {userOrg.user.firstName
                          ? userOrg.user.lastName
                            ? `${userOrg.user.firstName.charAt(
                                0
                              )}${userOrg.user.lastName.charAt(
                                0
                              )}`.toUpperCase()
                            : `${userOrg.user.firstName.charAt(
                                0
                              )}${userOrg.user.firstName.charAt(
                                1
                              )}`.toUpperCase()
                          : `${userOrg.user.email.charAt(
                              0
                            )}${userOrg.user.email.charAt(1)}`.toUpperCase()}
                      </div>
                    </div>
                    <div className="capitalize text-gray-700 text-sm">
                      {userOrg.user.userOrganisation &&
                        userOrg.user.userOrganisation[0].role
                          ?.toLowerCase()
                          .replaceAll("_", " ")}
                    </div>
                  </div>
                  <hr className="h-px w-[98%] my-1 mx-auto bg-gray-200 border-0 " />
                </>
              ))}
          </div>
          <div className="text-sm text-gray-400">
            {t("pending projects/tasks Description")}
          </div>
          <div className="flex justify-end gap-2">
            <Button
              size={"sm"}
              variant={"destructive"}
              onClick={() => {
                setReAssign(false);
                setReAssignUser(undefined);
              }}
            >
              {t("cancel")}
            </Button>
            <Button
              size={"sm"}
              variant={"primary"}
              disabled={
                Boolean(!reAssingUser?.newUserId) ||
                removeOrganisationMemberMutation.isPending ||
                reAssgingTaskMutation.isPending
              }
              onClick={() => handleReAssign()}
            >
              {t("submit")}
            </Button>
          </div>
        </div>
      </Dialog>
      <Dialog
        isOpen={Boolean(blocker.state === "blocked") || tabChange}
        onClose={() => {
          // blocker.reset();
        }}
        modalClass="rounded-lg w-3/12 text-center"
      >
        <div className="flex flex-col gap-2 p-6 ">
          <LucideAlertTriangle className="w-12 m-auto" />{" "}
          {t("route_block_message")}
          <div className="flex gap-2 ml-auto">
            <Button
              variant={"primary"}
              onClick={() => {
                blocker.reset && blocker.reset();
                setTabChange(false);
              }}
            >
              {t("ok")}
            </Button>
          </div>
        </div>
      </Dialog>
      <Dialog
        isOpen={Boolean(isAvailabilityOpen)}
        modalClass="rounded-md w-1/2"
        onClose={() => setIsAvailabilityOpen("")}
        // ref={popupRef}
      >
        <div className="p-4">
          <div className="flex justify-end items-center">
            <img
              className="select-none cursor-pointer"
              src={Close}
              alt="No ImageFound"
              onClick={() => {
                setIsAvailabilityOpen("");
                setReasonForLeave("");
                setUpdateMemberData(undefined);
                // setEditingReason(undefined);
                // setEditingStartDate(undefined);
                // setEditingEndDate(undefined);
                // setCalendarOpenFor(null)
              }}
            />
          </div>
          <div className={`text-left w-full flex-col`}>
            <div>
              <label className={labelStyle + "mb-0 text-xl !font-bold"}>
                {t("availability")}
              </label>
            </div>
            <div className="flex gap-2">
              <span>{updateMemberData?.user.firstName}</span>
              <span>{updateMemberData?.user.lastName}</span>
            </div>

            <div className="flex gap-2">
              <span>{updateMemberData?.user.email}</span>
            </div>
            <hr className="mt-3" />
            <div className="flex justify-between gap-2 items-end ">
              <div className="flex flex-col mt-2 ">
                <label className={labelStyle + "mb-0 text-sm"}>
                  {`Reason`} <span className="ml-0.5 text-red-500">*</span>
                </label>

                <InputText
                  name="reason"
                  id="reason"
                  placeholder="Reason for leave"
                  value={reasonForLeave}
                  onChange={(e) => {
                    setReasonForLeave(e.target.value);
                    if (e.target.value.trim()) {
                      setIsReasonError(false);
                    }
                  }}
                />

                {isReasonError && (
                  <span className="text-red-500 text-xs mt-1">
                    Reason is required
                  </span>
                )}
              </div>
              <div className="mt-2 flex justify-end">
                <Popover open={isPopoverOpen} onOpenChange={setIsPopoverOpen}>
                  <PopoverTrigger asChild>
                    <div
                      className="bg-primary-500 hover:bg-primary-500 rounded-md px-2 py-4 text-white"
                      onClick={(e) => {
                        if (!reasonForLeave.trim()) {
                          e.preventDefault(); // stop Radix from opening
                          setIsReasonError(true);
                          return;
                        }
                        setIsReasonError(false);
                        setIsPopoverOpen(true); // manually open
                      }}
                    >
                      <div className="flex w-full gap-2 justify-start items-center text-center">
                        <CalendarIcon className="w-4" />
                        <div>{t("Add Absence")}</div>
                      </div>
                    </div>
                  </PopoverTrigger>

                  <PopoverContent className="p-3" side="left">
                    <Calendar
                      mode="range"
                      fromYear={2020}
                      toYear={2300}
                      captionLayout="dropdown-buttons"
                      selected={selectedRange}
                      onSelect={setSelectedRange}
                      disabled={[
                        { dayOfWeek: nonWorkingDays() },
                        ...(holiday ?? []),
                        ...availabilityRanges,
                        // { before: today },
                      ]}
                    />
                    <div className="flex justify-end gap-2 mt-3">
                      <Button
                        size="sm"
                        variant="ghost"
                        onClick={() => setSelectedRange(undefined)}
                      >
                        {t("clear")}
                      </Button>
                      <Button
                        size="sm"
                        onClick={addSelectedAbsence}
                        disabled={!selectedRange?.from}
                        className="bg-primary-500 hover:bg-primary-500"
                      >
                        {t("Add")}
                      </Button>
                    </div>
                  </PopoverContent>
                </Popover>
              </div>
            </div>
          </div>
          <div className="mt-3.5 w-full">
            <Table
              columnDef={availabilityColumnDef}
              data={filterAvailableTableData ?? []}
              className="!p-0"
            />
          </div>
        </div>
      </Dialog>

      <Dialog
        isOpen={isAdminConfirmOpenPopUp}
        onClose={() => setIsAdminConfirmOpenPopUp(false)} // Allow closing dialog
        modalClass="rounded-lg"
      >
        <div className="flex flex-col gap-2 p-6 ">
          <img src={TrashCan} className="w-12 m-auto" />{" "}
          {t("common_delete_message")}
          <div className="flex gap-2 ml-auto">
            <Button
              variant={"outline"}
              onClick={() => setIsAdminConfirmOpenPopUp(false)}
            >
              {t("cancel")}
            </Button>
            <Button
              variant={"primary"}
              onClick={() => remove(availabilityDataId)}
            >
              {t("delete")}
            </Button>
          </div>
        </div>
      </Dialog>
    </div>
  );
};
export default OrganisationDetails;